import { request, Response } from '../utils';
import { Session } from '../types';

export const deleteGraphPermission = (body: {
  session: Session;
  graphID: string;
  authorizedUsername: string;
}): Response<null> => request('delete-graph-permission', body);
